import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography } from '@mui/material';
import { Image, PaintBrush } from '@phosphor-icons/react';
import { SyntheticEvent, useState } from 'react';
import { LogoAndIcons } from './LogoAndIcons';
import { Theme } from './Theme';

interface EmbedOptionProps {
  chatData: any;
  onSetFlow: any;
}

export function CustomizeInterface({ chatData, onSetFlow }: EmbedOptionProps) {
  const [value, setValue] = useState('1');

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      width="100%"
      height="600px"
    >
      <Box display="flex" flexDirection="column" gap="16px" width="100%">
        <Box display="flex" alignItems="center" gap="8px" width="100%" mb="8px">
          <PaintBrush size={20} color="#101828" />
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '500',
              color: '#101828',
            }}
          >
            Customize Interface
          </Typography>
        </Box>

        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                label={
                  <Box display="flex" gap="8px" alignItems="center">
                    <Image size={20} />
                    Logos and Icons
                  </Box>
                }
                value="1"
              />
              <Tab
                label={
                  <Box display="flex" gap="8px" alignItems="center">
                    <PaintBrush size={20} />
                    Choose Design
                  </Box>
                }
                value="2"
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ padding: '0px' }}>
            <LogoAndIcons chatData={chatData} onSetFlow={onSetFlow} />
          </TabPanel>

          <TabPanel value="2" sx={{ padding: '0px' }}>
            <Theme chatData={chatData} onSetFlow={onSetFlow} />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}
